<script setup lang="ts">
  import { ref } from 'vue';
  import { TabsMenu } from '@/shared/ui';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import GrantEditor from './GrantEditor.vue';
  import LabSection from './LabSection.vue';
  import RequiredEditor from './RequiredEditor.vue';
  import RuleEditor from './RuleEditor.vue';

  type Tab = 'rule' | 'grant' | 'required';

  const lab = useMatrixFillLabContext();
  const tab = ref<Tab>('rule');

  const TABS: { id: Tab; text: string }[] = [
    { id: 'rule', text: 'Regra' },
    { id: 'grant', text: 'Permissão' },
    { id: 'required', text: 'Obrigatoriedade' },
  ];
</script>

<template>
  <LabSection
    title="Simular regra ou permissão nova"
    nested
    :badge="lab.labRules.value.length + lab.labGrants.value.length + lab.requiredFieldIds.value.size || null"
    hint="Nada aqui é salvo. O que você cria entra na mesma entrada que a matriz salva e o compilador trata os dois do mesmo jeito."
    data-testid="lab-simulate"
  >
    <div class="text-[11px]">
      <TabsMenu
        :options="TABS"
        :selected-option="tab"
        visual-variant="neutral"
        @option-selected="tab = $event as Tab"
      />
    </div>
    <RuleEditor v-if="tab === 'rule'" />
    <GrantEditor v-else-if="tab === 'grant'" />
    <RequiredEditor v-else />
  </LabSection>
</template>
